import { SetStateAction, useState } from "react";
import { isSelectable, ItemType, showMenu, StringObj, TableIndexProps } from "./TableIndex";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import TableMenu from "./TableMenu";
import { styled } from "@mui/styles";
import FactorViewComponent from "components/Factor/factorView/FactorViewComponent";
import PrintInstallment from "components/installment2/Print/PrintInstallMent";
import TableSearchMenu from "./TableSearchMenu";
import TableCheckbox from "./TableCheckbox";
import { useDispatch } from "react-redux";
import LeftArrowImg from "assets/images/LeftArrow.svg";
import EditImg from "assets/images/Edit.svg";
import CopyImg from "assets/images/Copy.svg";
import PrintImg from "assets/images/Print.svg";
import InvoiceImg from "assets/svg/invoice-bill-svgrepo-com.svg";
import DeleteImg from "assets/images/Delete.svg";
import StatusComponent from "./StatusComponent";
import useLabelPrint from "components/Factor2/print/useLabelPrint";
import FileUploadModal from "../fileUploadModal/FileUploadModal";
import Archive from "../../assets/svg/Archive/gray.svg";
import OfficialPrint from "../Factor/OfficialPrint";
import RemittancePrint from "../Remittance/print/RemittancePrint";
import AccountingPrint from "../Accounting/print/AccountingPrint";
import Moaddian from "assets/svg/iconSidebar/transaction.svg";
import PenEdit from "assets/svg/pen-icon-account.svg";
import Inquiry from "assets/svg/serach-select-box-tree.svg";
import { apiMoaddianInquiry, apiSendToCancel, apiSendToInvoice } from "../../api/moaddian";
import { useAppSelector } from "../../store/store";
import { getDefaultCurrency } from "helpers";
import SumComp from "./SumComp";
import ModdianModalFactorEdit from "components/ModdianModalFactorEdit/ModdianModalFactorEdit";
import { appSetAlert } from "store/actions/appAction";
import ForeignPrint from "components/Factor/ForeignPrint";
import { setInstallment } from "store/actions/installmentAction";
import PrintSalary from "components/Reports/PrintSalary";

export default function TableBodyComp(props: TableIndexProps) {
  const { actions, sumAmountInfo } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { SettingsModal, openModal } = useLabelPrint();
  const [searchColumn, setSearchColumn] = useState("");
  const [archiveModel, setArchiveModel] = useState(null);
  const [showArchiveModel, setShowArchiveModel] = useState(false);
  const [openModelModdian, setOpenModelModdian] = useState({ open: false, factorId: "" });
  const [generateFactorId, setGenerateFactorId] = useState<{ id?: number | string; key?: number }>();
  const [exitFactorInventory, setExitFactorInventory] = useState<{ id?: number | string; key?: number }>();
  const [invoiceFactorId, setInvoiceFactorId] = useState<{ id?: number | string; key?: number }>();
  const [remittanceId, setRemittanceId] = useState<{ id?: number | string; key?: number }>();
  const [salaryFishId, setSalaryFishId] = useState<{ id?: number | string; key?: number }>();
  const [accountingId, setAccountingId] = useState<{ id?: number | string; key?: number }>();
  const [installmentId, setInstallmentId] = useState<{ id?: number | string; key?: number }>();
  const [foreignPrintId, setForeignPrintId] = useState<{ id?: number | string; key?: number }>();
  const store = useAppSelector((state: any) => state);
  const dataTableReducer = store.dataTableReducer
  const businessState = store.businessReducer;
  const { currencies } = store.currencyReducer;
  const sumAmount = dataTableReducer?.sumAmount
  const sumAmountFinal = dataTableReducer?.sumAmountFinal

  const business = businessState.business;
  const businessId = business.id as number

  const currency = getDefaultCurrency(business.business.default_currency_id, currencies);
  const onPrintClicked = (factorId: number | string) => {
    setGenerateFactorId({ id: factorId, key: Math.random() });
  };

  const onInvoiceClicked = (factorId: number | string) => {
    setInvoiceFactorId({ id: factorId, key: Math.random() });
  };
  const onForeignPrintClicked = (factorId: string | number) => {
    setForeignPrintId({ id: factorId, key: Math.random() })
  }
  const onRemittanceClicked = (remittanceId: number | string) => {
    setRemittanceId({ id: remittanceId, key: Math.random() });
  };
  const onSalaryFishPrint = (salaryFishId: number | string) => {
    setSalaryFishId({ id: salaryFishId, key: Math.random() })
  }
  const onAccountingClicked = (accountingId: number | string) => {
    setAccountingId({ id: accountingId, key: Math.random() });
  };
  const onPrintinstallments = (installment: number | string) => {
    setInstallmentId({ id: installment, key: Math.random() });
  };
  const editItem = (item: ItemType) => {
    const factorTypes = ["buy", "buyReturn", "sale", "saleReturn", "waste"];
    const transactionTypes = ["income", "cost", "receive", "payment"];
    if (factorTypes.includes(props.activeTab.key)) {
      navigate(`${props.activeTab.key}/${item.id}`);
      // navigate(`./${props.activeTab.key}/${item.id}`);
    } else if (transactionTypes.includes(props.activeTab.key)) {
      navigate(`${props.activeTab.key}/${item.id}`);
      // navigate(`./${props.activeTab.key}/${item.id}`);
    } else if (props.activeTab.key === "estimate" || props.activeTab.key === "allFactors" || props.activeTab.key === "withoutBill") {
      navigate(`${item.type}/${item.id}`);
      // navigate(`./${item.type}/${item.id}`);
    } else {
      navigate(`${item.id}`);
    }
  };

  const copyItem = (item: ItemType) => {
    const factorTypes = ["buy", "buyReturn", "sale", "saleReturn", "waste"];
    const transactionTypes = ["income", "cost", "receive", "payment"];
    if (factorTypes.includes(props.activeTab.key)) {
      navigate(`./${props.activeTab.key}/${item.id}?copy=1`);
    } else if (transactionTypes.includes(props.activeTab.key)) {
      navigate(`./${props.activeTab.key}/${item.id}?copy=1`);
    } else if (props.activeTab.key === "estimate" || props.activeTab.key === "allFactors") {
      navigate(`./${item.type}/${item.id}?copy=1`);
    } else {
      navigate(`./${item.id}?copy=1`);
    }
  };

  const tableMenuItems = (item: any) => {
    return [
      {
        Label: <img src={LeftArrowImg} alt="" />,
        icon: (
          <span
            style={{
              color: "#95A3B5",
              fontSize: "14px",
              fontWeight: 500
            }}
          >
            {actions?.view?.label || "مشاهده"}
          </span>
        ),

        onClick: () => {
          if (actions?.view?.openDrawer) actions.view.openDrawer(dispatch, item);
          else navigate(`${actions.view.url}?${actions.view.id}=${item.id}&factorType=${props.activeTab.key}`);
        },
        show: !!actions.view
      },
      {
        label: "ویرایش",
        icon: <img src={EditImg} alt="" />,
        onClick: () => {
          if (item?.taxPaymentStatus && item.taxPaymentStatus !== null) {
            return dispatch(appSetAlert("به دلیل ثبت در سامانه مودیان امکان ویرایش وجود ندارد", "error"))
          }
          editItem(item)
        },
        show: !!actions.edit
      },
      {
        label: "کپی",
        icon: <img src={CopyImg} alt="" />,
        onClick: () => copyItem(item),
        show: !!actions.copy
      },
      {
        label: "فیش پرینت",
        icon: <img src={InvoiceImg} alt="" />,
        onClick: () => onPrintClicked(item.id),
        show: !!actions.print
      },
      {
        label: "چاپ حواله خروج",
        icon: <img src={InvoiceImg} alt="" />,
        onClick: () => setExitFactorInventory({ id: item.id, key: Math.random() }),
        show: !!actions.printExitFromInventory
      },
      {
        label: "فاکتور رسمی",
        icon: <img src={PrintImg} alt="" />,
        onClick: () => onInvoiceClicked(item.id),
        show: !!actions.invoice
      },
      {
        label: "فاکتور به زبان انگلیسی",
        icon: <img src={PrintImg} alt="" />,
        onClick: () => onForeignPrintClicked(item.id),
        show: !!actions.invoice && [4583, 14877].includes(item.BusinessId)//14877
      },
      {
        label: "چاپ رسید / حواله",
        icon: <img src={PrintImg} alt="" />,
        onClick: () => onRemittanceClicked(item.id),
        show: !!actions.printRemittance
      },
      {
        label: "چاپ فیش حقوقی",
        icon: <img src={PrintImg} alt="" />,
        onClick: () => onSalaryFishPrint(item.id),
        show: !!actions.printFishSalary
      },
      {
        label: "خروجی اکسل",
        icon: <img src={PrintImg} alt="" />,
        onClick: () => actions.singleExcel && dispatch(actions.singleExcel.export(businessState?.business?.token, item.id)),
        show: !!actions.showSingleExcel
      },
      {
        label: "چاپ سند",
        icon: <img src={PrintImg} alt="" />,
        onClick: () => onAccountingClicked(item.id),
        show: !!actions.printAccounting
      },
      {
        label: "چاپ دفترچه اقساط",
        icon: <img src={PrintImg} alt="" />,
        onClick: () => onPrintinstallments(item.id),
        show: !!actions.printInstallments
      },
      {
        label: "اسناد",
        icon: <img src={Archive} alt="" />,
        onClick: () => {
          setShowArchiveModel(true);
          setArchiveModel(item);
        },
        show: !!actions.archive
      },
      {
        content: (item: any) => {
          const products = actions.getProducts ? actions.getProducts(item) : undefined;
          return (
            <div className="flex gap-2" onClick={() => openModal(item, products)}>
              <span>
                <img src={PrintImg} alt="" />
              </span>
              <span style={{ color: "#95A3B5", fontSize: "12px", fontWeight: 400 }}>چاپ لیبل</span>
            </div>
          );
        },
        show: !!actions.labelPrint
      },
      {
        Label: <span style={{ color: "#F42222", fontSize: "12px", fontWeight: 700 }}>ابطال</span>,
        icon: <img src={DeleteImg} alt="" />,
        //@ts-ignore
        onClick: () => dispatch(apiSendToCancel(item.id)),
        show: actions.cancelled
      },
      {
        Label: <span style={{ color: "#F42222", fontSize: "12px", fontWeight: 700 }}>حذف</span>,
        icon: <img src={DeleteImg} alt="" />,
        onClick: () => props.deleteItem(item.id, item),
        show: actions.delete

      },
      {
        Label: <span style={{ color: "#878787", fontSize: "12px", fontWeight: 700 }}>ارسال</span>,
        icon: <img src={Moaddian} alt="" />,
        //@ts-ignore
        onClick: () => dispatch(apiSendToInvoice(item.id)),
        show: actions.sendForTax
      },
      {
        Label: <span style={{ color: "#878787", fontSize: "12px", fontWeight: 700 }}>ویرایش مبلغ اقلام فاکتور</span>,
        icon: <img src={PenEdit} alt="" />,
        //@ts-ignore
        onClick: () => { setOpenModelModdian({ factorId: item.id, open: true }) },//dispatch(apiSendToInvoice(item.id)),
        show: actions.editMoaddian
      },
      // {
      //   Label: <span style={{ color: "#878787", fontSize: "12px", fontWeight: 700 }}>اصلاح اطلاعات</span>,
      //   icon: <img src={Moaddian} alt="" />,
      //   //@ts-ignore
      //   onClick: () => { dispatch(apiEditModdian(item.id)) },//dispatch(apiSendToInvoice(item.id)),
      //   show: actions.editMoaddian
      // },
      {
        Label: <span style={{ color: "#878787", fontSize: "12px", fontWeight: 700 }}>استعلام وضعیت</span>,
        icon: <img src={Inquiry} alt="" />,
        //@ts-ignore
        onClick: () => dispatch(apiMoaddianInquiry([item.id])),
        show: actions.inquiry
      },
      {
        Label: <span style={{ color: "#878787", fontSize: "12px", fontWeight: 700 }}>ارسال مجدد</span>,
        icon: <img src={Moaddian} alt="" />,
        onClick: () => {
          //اینجا باید چک شود ابطالی است یا ارسالی
          //@ts-ignore
          dispatch(apiSendToInvoice(item.id))

        },
        show: actions.reSendForTax
      }
    ];
  };

  const showItems = !props.loading && props.items != null && props.items.length > 0;

  const items: any = () => {
    let items = props.items.map((item: any, index) => {
      for (const title of props.titles) {
        if (!item?.hasOwnProperty(title.key)) {
          item[title.key] = props.displayValue(item, title, props.items);
        }
      }
      return item;
    });

    return items;
    // .sort((a, b) => {
    //     if (props.sortQuery) {
    //         if (a[props.sortQuery.key] < b[props.sortQuery.key]) {
    //             return props.sortQuery.dir === "DESC" ? 1 : -1;
    //         }
    //         if (a[props.sortQuery.key] > b[props.sortQuery.key]) {
    //             return props.sortQuery.dir === "DESC" ? -1 : 1;
    //         }
    //
    //         // names must be equal
    //     }
    //     return 0;
    // });
  };
  return (
    <tbody >
      <tr>
        <td
          style={{
            height: "45px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <SearchIcon fontSize="small" style={{ color: "#AEAEAE" }} />
        </td>
        {isSelectable(props.actions) && <td></td>}
        {props.titles.map((title, index) => {
          return (
            <td key={index}>
              <TableSearchMenu
                {...props}
                title={title}
                searchColumn={searchColumn}
                onChangeSearchColumn={(value: SetStateAction<string>) => setSearchColumn(value)}
              />
            </td>
          );
        })}
        <td className="fixed-column" style={{ backgroundColor: "#FFFFFF" }} />
      </tr>
      {showItems &&
        items().map((item: any, index: any) => {
          const itemAsStringObj = item as unknown as StringObj;
          return (
            <tr
              key={index}
              className={
                props.selectedItems.includes(item.id) == true
                  ? "new-active-item-data-table"
                  : "item-data-table"
              }
            >
              {isSelectable(props.actions) && (
                <td>
                  <TableCheckbox
                    checked={props.selectedItems.includes(item.id)}
                    onChange={() => props.selectItem(item.id)}
                  />
                </td>
              )}
              <td className="hashtag-item">{1 + index + (props.page - 1) * props.limit}</td>
              {props.titles.map((title, key) => {
                const Component = title.Component || null;
                return (
                  <td
                    key={key}
                    className="item-data-body"
                    style={{
                      //   color: `${title.clickable && title.clickable(item) ? "#856" : "#333333"}`,
                      textAlign: "right",
                      direction: "ltr"
                    }}
                    onClick={
                      () =>
                        props.secretView || itemAsStringObj[title.key] === undefined || title.navigate
                          ? null
                          : title.onClick
                            ? title.onClick(dispatch, item)
                            : null
                      // props.copyText(itemAsStringObj[title.key])
                    }
                  >
                    <div className="text-item" style={{ direction: "rtl" }}>
                      {Component && !props.secretView ? (
                        <Component item={item} value={props.displayValue(item, title, items())}
                          col={title} />
                      ) : title.key === "status" ? (
                        <StatusComponent
                          title={item.status}
                          value={props.displayValue(item, title, items())}
                        />
                      ) : (
                        <span
                          className={`${title.clickable && title.clickable(item) ? "hover:text-blue-1" : ""}`}
                        >
                          {props.displayValue(item, title, items())}
                        </span>
                      )}
                    </div>
                  </td>
                );
              })}
              {showMenu(props.actions) && (
                <td className="fixed-column" style={{ backgroundColor: "#FFFFFF" }}>
                  <TableMenu
                    item={item}
                    actions={actions}
                    items={tableMenuItems(item)}
                    isEditable={item?.isEditable ?? false}
                  />
                </td>
              )}
              {generateFactorId && generateFactorId.id === item.id && (
                <FactorContainer key={generateFactorId.key}>
                  <FactorViewComponent autoPrint={true} factorId={item.id}
                    factorType={props.activeTab.key} />
                </FactorContainer>
              )}
              {exitFactorInventory && exitFactorInventory.id === item.id && (
                <FactorContainer key={exitFactorInventory.key}>
                  <RemittancePrint autoPrint={true}
                    factorId={item.id}
                    //remittanceId={item.id}
                    remittanceType={"sale"} />
                </FactorContainer>
              )

              }

              {invoiceFactorId && invoiceFactorId.id === item.id && (
                <FactorContainer key={invoiceFactorId.key}>
                  <OfficialPrint autoPrint={true} factorId={item.id} factorType={props.activeTab.key} />
                </FactorContainer>
              )}
              {
                foreignPrintId && foreignPrintId.id === item.id && (
                  <FactorContainer key={foreignPrintId.key}>
                    <ForeignPrint autoPrint={true} factorId={item.id} factorType={props.activeTab.key} />
                  </FactorContainer>
                )
              }
              {remittanceId && remittanceId.id === item.id && (
                <FactorContainer key={remittanceId.key}>
                  <RemittancePrint autoPrint={true} remittanceId={item.id}
                    remittanceType={props.activeTab.key} />
                </FactorContainer>
              )}
              {salaryFishId && salaryFishId.id === item.id && (
                <FactorContainer key={salaryFishId.key}>
                  <PrintSalary autoPrint={true} salaryId={item.id} />
                </FactorContainer>
              )}
              {accountingId && accountingId.id === item.id && (
                <FactorContainer key={accountingId.key}>
                  <AccountingPrint autoPrint={true} accountingId={item.id}
                    accountingType={props.activeTab.key} />
                </FactorContainer>
              )}
              {installmentId && installmentId.id === item.id && (
                <FactorContainer key={installmentId.key}>
                  <PrintInstallment autoPrint={true} installmentId={item.id}
                    installmentType={item.type} index={index} />
                </FactorContainer>
              )}
            </tr>
          );
        })}
      <SettingsModal />
      {archiveModel && showArchiveModel && (
        <FileUploadModal
          type={actions.archive.model}
          model={archiveModel}
          onCloseModal={() => {
            setShowArchiveModel(!showArchiveModel);
          }}
        />
      )}
      {openModelModdian.open && <ModdianModalFactorEdit open={openModelModdian} setOpen={setOpenModelModdian} />}
      {sumAmount?.length ? <SumComp currency={currency} isSelectable={isSelectable(props.actions)} sumAmountInfo={sumAmountInfo} title="جمع" titles={props.titles} key={"sumpage"} sumInfo={sumAmount} /> : null}
      {sumAmountFinal?.length ? <SumComp currency={currency} isSelectable={isSelectable(props.actions)} sumAmountInfo={sumAmountInfo} title="جمع کل صفحات" titles={props.titles} key={"sumpageَfinallll"} sumInfo={sumAmountFinal} /> : null}
    </tbody>
  );
}
const FactorContainer = styled("div")({
  position: "fixed",
  display: "none"
});
